export default __webpack_public_path__ + "static/media/Rastech-update-2.55187a20.jpg";